import SvgIcon from '~/components/SvgIcon';
import {
    iconEmail,
    iconEmbed,
    iconFacebookShare,
    iconLine,
    iconLink,
    iconLinkedIn,
    iconPinterest,
    iconPlaneShare,
    iconTelegram,
    iconTwitter,
    iconWhatsApp,
} from '~/components/SvgIcon/iconsRepo';

const shares = [
    {
        title: '嵌入',
        icon: <SvgIcon icon={iconEmbed} />,
    },
    {
        title: '发送给朋友',
        icon: <SvgIcon icon={iconPlaneShare} />,
    },
    {
        title: '分享到 Facebook',
        icon: <SvgIcon icon={iconFacebookShare} />,
        href: 'https://facebook.com',
    },
    {
        title: '复制链接',
        icon: <SvgIcon icon={iconLink} />,
    },
    {
        title: '分享到 WhatsApp',
        icon: <SvgIcon icon={iconWhatsApp} />,
        href: 'https://wa.me',
    },
    {
        title: '分享到 Twitter',
        icon: <SvgIcon icon={iconTwitter} />,
        href: 'https://twitter.com',
    },
    {
        title: '分享到 LinkedIn',
        icon: <SvgIcon icon={iconLinkedIn} />,
        href: 'https://www.linkedin.com',
    },
    {
        title: '分享到 Telegram',
        icon: <SvgIcon icon={iconTelegram} />,
        href: 'https://t.me',
    },
    {
        title: '分享到 Email',
        icon: <SvgIcon icon={iconEmail} />,
        href: 'mailto:',
    },
    {
        title: '分享到 Line',
        icon: <SvgIcon icon={iconLine} />,
        href: 'https://lineit.line.me',
    },
    {
        title: '分享到 Pinterest',
        icon: <SvgIcon icon={iconPinterest} />,
        href: 'https://pinterest.com',
    },
];

export default shares;
